// @ts-nocheck

import React, { useContext } from 'react'
import LargeUnitCard from 'components/LargeUnitCard'
import SelectUnit from './SelectUnit'
import { CreateOfferContext } from '../context/CreateOfferContext'

const Step1 = (props) => {
  const { setStep } = props

  const { selectedUnit, setSelectedUnit } = useContext(CreateOfferContext)

  const onSelect = (unit) => {
    if (unit.status !== 'SoldCommitted') {
      setSelectedUnit(unit)
    }
  }

  const onBack = () => {
    setSelectedUnit({})
  }

  const isSelected = Object.values(selectedUnit).length > 0

  return (
    <div>
      <div className='pb-4 border-b-2 border-softBlack mb-10'>
        <p className='my-0 text-xl font-bold'>
          {isSelected ? 'Units Details' : 'Select Unit'}
        </p>
      </div>
      {!isSelected && <SelectUnit onSelect={onSelect} />}
      {isSelected && (
        <>
          <LargeUnitCard
            imgsrc={selectedUnit?.floorPlan?.image}
            unitName={`#${selectedUnit?.unitNumber}`}
            noOfBedrooms={selectedUnit?.numberOfBedrooms}
            noOfBathrooms={selectedUnit?.numberOfBathrooms}
            balcony={selectedUnit?.balcony}
            noOfParkingSlot={selectedUnit?.floorPlan?.parkingQty}
            building={selectedUnit?.building?.name}
            price={selectedUnit?.price}
          />
          <div className='flex justify-between mt-32'>
            <button
              className='py-3 px-6 text-base bg-softBlack text-white rounded'
              onClick={onBack}
            >
              Back
            </button>
            <button
              className='py-3 px-6 text-base bg-volt rounded'
              onClick={() => setStep((prev) => prev + 1)}
            >
              Next
            </button>
          </div>
        </>
      )}{' '}
    </div>
  )
}

export default Step1
